import React from "react";
import {
  invoiceDesignFontFamily,
  invoiceDesignTokens,
} from "../Invoicing/InvoiceDesignSystem";

export type ReportSectionCardProps = {
  title: string;
  headingAction?: React.ReactNode;
  description?: string;
  children: React.ReactNode;
  className?: string;
  // Design (21) Reports Page Mockup :47-52, :471-472: the Report Period card
  // stands out (2px gold border, soft gold glow) until both dates are set.
  highlight?: boolean;
  titleAdornment?: React.ReactNode;
  sectionRef?: React.Ref<HTMLElement>;
};

const ReportSectionCard = ({
  title,
  headingAction,
  description,
  children,
  className = "",
  highlight = false,
  titleAdornment,
  sectionRef,
}: ReportSectionCardProps) => (
  <section
    ref={sectionRef}
    className={`flex min-w-0 flex-col gap-4 rounded-xl bg-white p-6 transition-[border-color,box-shadow] duration-200 ${className}`}
    style={{
      border: highlight ? "2px solid #E1A731" : `1px solid ${invoiceDesignTokens.modalBorder}`,
      boxShadow: highlight ? "0 0 0 4px rgba(225,167,49,.18)" : "0 1px 2px rgba(0,0,0,.04)",
      scrollMarginTop: 24,
      color: invoiceDesignTokens.ink,
      fontFamily: invoiceDesignFontFamily,
    }}
  >
    <div className="flex flex-wrap items-center justify-between gap-[14px]">
      <div className={description ? "flex min-w-[200px] flex-[1_1_200px] flex-col gap-1" : undefined}>
        <div className="flex flex-wrap items-center gap-[10px]">
          <h2 className="m-0 text-[16px] font-semibold leading-[19px]">{title}</h2>
          {titleAdornment}
        </div>
        {description && <p className="m-0 text-[13px] leading-[18px] text-[#727272]">{description}</p>}
      </div>
      {headingAction}
    </div>
    {children}
  </section>
);

export default ReportSectionCard;
